import { useContext } from 'react'

import { AuthContext, type AuthState } from './auth-context'

/**
 * Giriş yapmış kimlik.
 *
 * Sağlayıcı dışında null'ımsı bir varsayılan döndürmek yerine fırlatır: ağacın dışında kimlik
 * okuyan bir bileşen bir bağlama hatasıdır ve sessiz bir "kimse girmemiş", sebebi gösteren bir
 * yığın izi yerine giriş ekranına gizemli bir yönlendirme olarak ortaya çıkardı.
 */
export function useAuth(): AuthState {
  const context = useContext(AuthContext)

  if (context === null) {
    throw new Error('useAuth yalnız AuthProvider içinde kullanılabilir.')
  }

  return context
}
